import {useIsFocused} from '@react-navigation/native';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {getClassrooms} from '../../../apis';
import {px, useAsync, useIsLandscape} from '../../../utils';
import {AppLoadingIndicator, Page} from '../../components';
import CardsList from './components/CardsList';
import FilterModal from './components/FilterModal';
import TopCalendar from './components/TopCalendar';

const sortByTime = (items) => {
  let list = items.sort(function (a, b) {
    return (
      Date.parse('1970/01/01 ' + a.startTime) -
      Date.parse('1970/01/01 ' + b.startTime)
    );
  });
  return list;
};

const Classroom = () => {
  const isFocused = useIsFocused();
  const isLandscape = useIsLandscape();
  const kids = useSelector((state) => state.general.kids);
  const today = moment.utc();
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedKids, setSelectedKids] = useState([...kids]);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [datesCache, setDatesCache] = useState({});

  useEffect(() => {
    if (isFocused) {
      // reset cache
      setDatesCache({});
      setSelectedDate(today);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const {
    loading: selectedDateLoading,
    value: selectedDateList,
  } = useAsync(async () => {
    const date = selectedDate.format('YYYY-MM-DD');
    if (datesCache[date]) {
      return Promise.resolve(datesCache[date]);
    }
    var result = await getClassrooms({
      kidIds: selectedKids.map(({id}) => id),
      date,
    });
    result = sortByTime(result);
    setDatesCache((prev) => ({...prev, [date]: result}));
    return result;
  }, [selectedDate, selectedKids]);

  const {
    loading: prevSelectedDateLoading,
    value: prevSelectedDateList,
  } = useAsync(async () => {
    if (!isLandscape) {
      return Promise.resolve();
    }
    const date = selectedDate.clone().add(-1, 'day').format('YYYY-MM-DD');
    if (datesCache[date]) {
      return Promise.resolve(datesCache[date]);
    }
    var result = await getClassrooms({
      kidIds: selectedKids.map(({id}) => id),
      date,
    });

    result = sortByTime(result);
    setDatesCache((prev) => ({...prev, [date]: result}));
    return result;
  }, [selectedDate, selectedKids, isLandscape]);

  const {
    loading: nextSelectedDateLoading,
    value: nextSelectedDateList,
  } = useAsync(async () => {
    if (!isLandscape) {
      return Promise.resolve();
    }
    const date = selectedDate.clone().add(1, 'day').format('YYYY-MM-DD');
    if (datesCache[date]) {
      return Promise.resolve(datesCache[date]);
    }
    var result = await getClassrooms({
      kidIds: selectedKids.map(({id}) => id),
      date,
    });
    result = sortByTime(result);
    setDatesCache((prev) => ({...prev, [date]: result}));
    return result;
  }, [selectedDate, selectedKids, isLandscape]);

  return (
    <>
      <Page header={{title: 'Join Classroom', showDrawerAction: true}}>
        <TopCalendar
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <View style={styles.viewStyle}>
          {isLandscape && (
            <View style={styles.col}>
              {prevSelectedDateLoading ? (
                <AppLoadingIndicator />
              ) : (
                <CardsList data={prevSelectedDateList} />
              )}
            </View>
          )}
          <View style={styles.col}>
            {selectedDateLoading ? (
              <AppLoadingIndicator />
            ) : (
              <CardsList data={selectedDateList} />
            )}
          </View>
          {isLandscape && (
            <View style={styles.col}>
              {nextSelectedDateLoading ? (
                <AppLoadingIndicator />
              ) : (
                <CardsList data={nextSelectedDateList} />
              )}
            </View>
          )}
        </View>
      </Page>
      <FilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        selectedKids={selectedKids}
        setSelectedKids={setSelectedKids}
      />
    </>
  );
};

const styles = StyleSheet.create({
  viewStyle: {
    flexDirection: 'row',
  },
  col: {
    height: '100%',
    flex: 1,
    alignItems: 'center',
  },
  headerIconsContainer: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
  },
  downloadText: {
    color: '#fff',
    fontSize: px(11),
  },
  headerIcon: {
    width: px(35),
    height: px(35),
    marginLeft: px(10),
  },
});

export default Classroom;
